module.exports = __webpack_public_path__ + "img/m-baseinfomation.c71829ba.svg";